import { selectStandardProps } from "@/utils/componentUtils";
import { Select } from "antd";
import { useEnumeration } from "../../../../common/api/queries";
import type { UUID } from "../../../../typings/global";
import { CommissionsSettingsRankBase } from "../../../commissions/ranks/types";
import { EnumerationType } from "../../enums";

type Props<T extends boolean> = {
  value?: T extends true ? UUID[] : UUID;
  allowClear?: boolean;
  isMultiple?: T;
  dataSource?: CommissionsSettingsRankBase[];
  onChange?: (data: T extends true ? UUID[] : UUID) => void;
  style?: React.CSSProperties;
};

export const CommissionsSettingsRankSelect = <T extends boolean>({
  style,
  dataSource,
  allowClear,
  isMultiple,
  onChange,
  value,
}: Props<T>) => {
  const ranksEnums = useEnumeration(EnumerationType.COMMISSIONS_SETTINGS_RANKS);
  const data = dataSource ?? ranksEnums;

  return (
    <Select
      style={style}
      {...selectStandardProps}
      allowClear={allowClear}
      maxTagCount="responsive"
      mode={isMultiple ? "multiple" : undefined}
      options={data.map((rank) => ({
        label: rank.name,
        value: rank.id,
      }))}
      onChange={onChange}
      value={value}
    />
  );
};
